export default __webpack_public_path__ + "static/media/donutLegendUp.bda2553b.svg";